import { motion, useReducedMotion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/lib/siteConfig";

export default function TestimonialsSection() {
  const reduced = useReducedMotion();
  return (
    <div
      data-testid="testimonials-section"
      className="grid grid-cols-1 md:grid-cols-3 gap-5"
    >
      {TESTIMONIALS.map((t, idx) => (
        <motion.figure
          key={idx}
          initial={reduced ? false : { opacity: 0, y: 10 }}
          whileInView={reduced ? undefined : { opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.45, delay: idx * 0.05, ease: [0.16, 1, 0.3, 1] }}
          data-testid={`testimonial-card-${idx + 1}`}
          className="relative bg-paper rounded-2xl border border-[rgba(74,63,57,0.10)] p-6 sm:p-7 overflow-hidden"
        >
          <Quote className="w-7 h-7 text-terracotta opacity-60 mb-3" />
          <blockquote className="text-ink leading-[1.75] text-[15px]">
            {t.quote}
          </blockquote>
          <figcaption className="mt-5 pt-4 border-t border-clay/60">
            <div className="font-display text-base text-ink">{t.name}</div>
            <div className="text-xs text-ink-muted mt-0.5">{t.role}</div>
          </figcaption>
          {t.placeholder && (
            <span className="absolute top-4 right-4 text-[10px] uppercase tracking-[0.18em] text-moss bg-[rgba(126,155,134,0.18)] px-2 py-1 rounded-full">
              Placeholder
            </span>
          )}
          {t.batch && (
            <span className="absolute top-4 right-4 text-[10px] uppercase tracking-[0.16em] text-moss bg-[rgba(126,155,134,0.18)] px-2 py-1 rounded-full">
              {t.batch}
            </span>
          )}
        </motion.figure>
      ))}
    </div>
  );
}
